
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.625 16.275a2.477 2.477 0 00-3.614 0l-2.737 2.738a2.485 2.485 0 000 3.617l25.299 25.368-19.98 19.995A20.678 20.678 0 0015.5 82.667v1.756a20.68 20.68 0 006.04 14.622l3.408 3.41a20.64 20.64 0 0014.611 6.045h1.756a20.643 20.643 0 0014.61-6.045L76.01 82.357l25.35 25.316a2.473 2.473 0 003.614 0l2.736-2.738a2.48 2.48 0 000-3.617L22.625 16.275zm25.814 78.843a10.321 10.321 0 01-7.124 3.049h-1.756a10.32 10.32 0 01-7.331-3.049l-3.356-3.358a10.338 10.338 0 01-3.046-7.337v-1.756a10.338 10.338 0 013.046-7.337l20.032-20.047 6.247 6.304L44.825 71.92a2.586 2.586 0 000 3.668l3.614 3.617a2.578 2.578 0 003.666 0l10.326-10.333 6.247 6.2L48.44 95.118zm53.953-70.163l-3.407-3.41A20.643 20.643 0 0084.373 15.5h-1.755a20.645 20.645 0 00-14.663 6.097L54.377 35.185l7.59 7.337 13.578-13.64a10.324 10.324 0 017.073-3.049h1.755a10.32 10.32 0 017.332 3.049l3.356 3.358a10.343 10.343 0 013.046 7.337v1.756a10.343 10.343 0 01-3.046 7.337L81.482 62.31l7.28 7.285 13.578-13.588a20.678 20.678 0 006.093-14.674v-1.756a20.68 20.68 0 00-6.04-14.622zm-23.13 23.353l-3.614-3.616a2.582 2.582 0 00-3.666 0l-4.027 4.081 7.28 7.285 4.027-4.081a2.584 2.584 0 000-3.669z"}})])
          )
        }
      }
    